import store from '@/store/store';
import Env from '@/env';

/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function auth({ next, router, to}) {

    const token = store.getters.getLoggedInUserToken;
    let selectedStore = store.getters['location/selected'];
    // console.log(token)
    // console.log(selectedStore)
    if (!token) {
      store.dispatch('snackbar/setSnackbar', {
        message: "Please login to process.",
        type: "warning"
      });
      if(selectedStore.slug){
        return router.push({ name: 'StoreProfile', params: { business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug, store_slug: selectedStore.slug }});
      } else {
        return router.push({ name: 'HomePage', params: { business_slug: to.params.business_slug ? to.params.business_slug : Env.defaultBusinessSlug }});
      }
    }
    return next();
}